import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import LoadingStar from 'app/common/components/LoadingStar';
import SharedZapActions from 'app/shared-zap/SharedZapActions';
import ZapContainer from 'app/dashboard/components/ZapContainer';
import runActions from 'app/common/components/runActions';
import { maybeWaitForStoreStateWithActions } from 'app/common/utils/ReduxUtils';
import { withAllServicesById } from 'app/service/components/WithAllServicesById';

const ZapOrLoadingStar = props => {
  if (!props.zap) {
    return <LoadingStar />;
  }
  return <ZapContainer {...props} shouldHideMenu={true} />;
};

const mapStateToProps = (state, props) => {
  return {
    zap: state.sharedZap.flows[props.sharedZapId],
    services: props.services,
  };
};

ZapOrLoadingStar.runActions = (store, props) => {
  const configs = [];

  // Check for shared zap.
  configs.push({
    test: state => state.sharedZap.sharedZaps[props.sharedZapId],
    action: () => SharedZapActions.loadSharedZap(props.sharedZapId),
    shouldWait: true,
  });

  // Load Shared Zap flow.
  configs.push({
    after: state => state.sharedZap.sharedZaps[props.sharedZapId],
    test: state => state.sharedZap.flows[props.sharedZapId],
    action: () => SharedZapActions.addSharedZapFlow(props.sharedZapId),
    shouldWait: true,
  });

  return maybeWaitForStoreStateWithActions(store, configs);
};

export default _.flowRight(
  withAllServicesById,
  runActions,
  connect(mapStateToProps)
)(ZapOrLoadingStar);
